import { useEffect, useMemo, useState } from 'react';
import { DebounceSettings, debounce } from 'lodash-es';

export function useDebounce<T>(value: T, delay: number, options?: DebounceSettings) {
  const [debouncedValue, setDebouncedValue] = useState(value);
  const debouncedSetValue = useMemo(
    () => debounce(setDebouncedValue, delay, options),
    [delay, options],
  );
  useEffect(() => {
    debouncedSetValue(value);
  }, [debouncedSetValue, value]);
  return debouncedValue;
}

/* eslint-disable-next-line @typescript-eslint/no-explicit-any */
export function useDebouncedCallback<T extends (...args: any) => any>(
  func: T,
  wait = 300,
  options?: DebounceSettings,
) {
  const debouncedCallback = useMemo(() => debounce(func, wait, options), [func, wait, options]);

  useEffect(() => {
    return () => debouncedCallback.cancel();
  }, [debouncedCallback]);

  return debouncedCallback;
}
